<script>
import { BCardGroup } from "bootstrap-vue";

export default {
  extends: BCardGroup
};
</script>